import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth, isStaff } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import GradePage from "@/pages/GradePage";
import HomePage from "@/pages/HomePage";
import SubjectPage from "@/pages/SubjectPage";
import MyFilesPage from "@/pages/MyFilesPage";
import ChatPage from "@/pages/ChatPage";
import RewardsPage from "@/pages/RewardsPage";
import MyRewardsPage from "@/pages/MyRewardsPage";
import PlansPage from "@/pages/PlansPage";
import AiPage from "@/pages/AiPage";
import AfterPaymentPage from "@/pages/AfterPaymentPage";
import SupportPage from "@/pages/SupportPage";
import AdminPage from "@/pages/admin/AdminPage";

function Loader() {
  return (
    <div className="min-h-screen grid place-items-center" data-testid="app-loader">
      <div className="h-10 w-10 rounded-full border-4 border-[#c8e6d3] border-t-[#1f5f42] animate-spin" />
    </div>
  );
}

function Protected({ children, staff }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.grade && loc.pathname !== "/grade") return <Navigate to="/grade" replace />;
  if (staff && !isStaff(user)) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
          <Route path="/grade" element={<Protected><GradePage /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<HomePage />} />
            <Route path="/subject/:subject" element={<SubjectPage />} />
            <Route path="/my" element={<MyFilesPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/rewards" element={<RewardsPage />} />
            <Route path="/my-rewards" element={<MyRewardsPage />} />
            <Route path="/plans" element={<PlansPage />} />
            <Route path="/ai" element={<AiPage />} />
            <Route path="/afterpayment" element={<AfterPaymentPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/admin" element={<Protected staff><AdminPage /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors offset={64} />
        </AuthProvider>
          );
          }
 
                                                                                                                                                                                                                                  
                                                                                                                          
  
                                                                                                                                                                                                                                                           

                                                                                                                                   